define(['zepto'], function ($) {
    'use strict';

    function activateBySpaceButton(evt) {
        if (evt.key === ' ') {
            evt.preventDefault();
            evt.stopPropagation();
            $(evt.target).click();
        }
    }

    function activateBySpaceOrEnterButton(evt) {
        if (evt.key === 'Enter') {
            evt.preventDefault();
            evt.stopPropagation();
            $(evt.target).click();
            return;
        }
        activateBySpaceButton(evt);
    }

    return {
        activateBySpaceButton,
        activateBySpaceOrEnterButton
    };
});
